import { ReactComponent as TrainingIcon } from 'assets/icons/training.svg';
import { ReactComponent as TournamentIcon } from 'assets/icons/tournament.svg';
import { ReactComponent as UnfinishedIcon } from 'assets/icons/unfinishedGame.svg';

import { SceneStatusFilterEnum } from './MatchView/MatchView';

interface GameIconProps {
  iconKey: SceneStatusFilterEnum;
  className?: string;
}

const GameStatusIcon = (props: GameIconProps) => {
  const { iconKey, className } = props;

  const svgCss = {
    width: 30,
    verticalAlign: 'top',
  };

  const gameIcons = {
    TRAINING: <TrainingIcon css={svgCss} className={className} />,
    TOURNAMENT: <TournamentIcon css={svgCss} className={className} />,
    UNFINISHED: <UnfinishedIcon css={svgCss} className={className} />,
    ALL: null,
  };

  return gameIcons[iconKey];
};

export default GameStatusIcon;
